import { getCountries } from '@onhandtech/onhand-fe-shared/lib/api/legacy/countries/get-countries'
import { call, put } from 'redux-saga/effects'

import { fetchFailure, fetchStart, fetchSuccess } from '../actions'

export function* getCountriesSaga() {
  yield put(fetchStart())

  const [error, data] = yield call(getCountries)

  if (error) {
    yield put(fetchFailure(error))
  } else {
    yield put(fetchSuccess(data))
  }
}
